import React from "react";
import { contextApiActions } from "../_redux/_constants";

const Reducer = (state, action) => {
     switch (action.type) {
          case contextApiActions.UI_CONFIRMATION_TOGGEL:
               return {
                    ...state,
                    uiConfirmationDetails: {
                         ...state.uiConfirmationDetails,
                         ...action.payload,
                    },
               };

          case contextApiActions.UI_MODAL_TOGGEL:
               return {
                    ...state,
                    uiModalDetails: {
                         ...state.uiModalDetails,
                         ...action.payload,
                    },
               };
          case contextApiActions.UI_LARGE_MODAL_TOGGEL:
               return {
                    ...state,
                    uiLargeModalDetails: {
                         ...state.uiLargeModalDetails,
                         ...action.payload,
                    },
               };
          case contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL:
               return {
                    ...state,
                    uiExtraLargeModalDetails: {
                         ...state.uiExtraLargeModalDetails,
                         ...action.payload,
                    },
               };
          case contextApiActions.UI_ERROR_MESSAGE_TOGGEL:
               return {
                    ...state,
                    uiErrorMessageDetails: {
                         ...state.uiErrorMessageDetails,
                         ...action.payload,
                    },
               };
          case contextApiActions.UI_SUCCESS_MESSAGE_TOGGEL:
               return {
                    ...state,
                    uiSuccessMessageDetails: {
                         ...state.uiSuccessMessageDetails,
                         ...action.payload,
                    },
               };
          case "SIDEBAR_TOGGLE":
               return {
                    ...state,
                    ui_sidebar_open: action.payload,
               };
          case "SIDEBAR_MENU_OPEN":
               return {
                    ...state,
                    ui_sidebar_menu_open: action.payload,
               };
               case "CHAT_BOX_MODAL":
                    return {
                        ...state,
                        ui_chat_box: {
                            ...state.ui_chat_box,
                            ...action.payload,
                        },
                    };

          case contextApiActions.SET_SIGNALR_CONNECTTION:

               console.log("=============================================")
               return {
                    ...state,
                    signalRConnaction: action.payload,
               };
          case participantConstants.PARTICIPANT_GET_TLC_CUSTOMERS_COMPLETE:
               return {
                    ...state,
                    tlcCustomers: action.payload
               };

          default:
               return state;
     }
};

export default Reducer;
